
import { defineComponent } from "vue";
import SvgIcon from "@/components/SvgIcon.vue";

export default defineComponent({
  name: "DevInfoView",
  components: { SvgIcon },
});
